/** Fallback provider themes used when API data is not yet available. */
export const PROVIDER_THEMES: Record<string, { color: string; name: string }> = {
  azure: { color: '#0078D4', name: 'Microsoft Azure' },
  aws: { color: '#FF9900', name: 'Amazon Web Services' },
  gcp: { color: '#4285F4', name: 'Google Cloud Platform' },
};

/**
 * Sets the --color-provider CSS custom property on the document root.
 * This drives Tailwind's `provider` color utility and any other CSS
 * referencing the variable.
 */
export function applyProviderTheme(providerCode: string): void {
  const theme = PROVIDER_THEMES[providerCode] || PROVIDER_THEMES.azure;
  document.documentElement.style.setProperty('--color-provider', theme.color);
}
